import { MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { ClassificacaoStore } from "../../stores/classificacao/ClassificacaoStore";
import moment from "moment";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { formatCpfOrCnpj } from "../../utils";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { IconButton } from "@mui/material";
import { observable } from "mobx";
import { toast } from "react-toastify";
import LoadingModal from "../loading/LoadingModal";
import { NFesStore } from "../../stores/nfe/NFesStore";
import { Tooltip } from "@blueprintjs/core";

const numeral = require("numeral");

interface ClassificacaoSummaryProps {
  onView(classId: number): void;
}

interface ClassificacaoSummaryState {}

@observer
export class ClassificacaoSummary extends React.Component<ClassificacaoSummaryProps, ClassificacaoSummaryState> {

  obs = observable({
    loading_danfes: false as boolean,
    loading_xmls: false as boolean,
    list: [],
    listChaveEventos: []
  })

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Chave, Nº, Valor)"
      />
    );
  };

  handleViewXML = async (nota: any) => {

    await ResultadoStore.download_xml(nota.chave, "Entrada", "NF-E", nota.data, ClassificacaoStore.obs.selectedEmpresa.cnpj);

  };

  handleViewPDF = async (nota: any) => {

    var ids = {
      ids: [nota.nota_id],
      filtro: "Entrada",
      tipo: "NF-E",
      empresa: ClassificacaoStore.obs.selectedEmpresa.cnpj,
      data1: ClassificacaoStore.obs.date_start,
      data2: ClassificacaoStore.obs.date_end,
    };

    await ResultadoStore.view_danfe(ids, nota.chave);

  };

  handleRowSelect = (row, isSelected, e) => {

    if (row.status == "Indisponível") {

      return false;

    } else {

      this.toggleItem(this.obs.list, row.nota_id);
      this.toggleItem(this.obs.listChaveEventos, row.chave);
    }

  };

  onSelectAll = (isSelect, rows) => {

    this.obs.list = []
    this.obs.listChaveEventos = []

    if (isSelect) {

      for (const imp of ClassificacaoStore.obs.summary) {
        this.obs.list.push(imp.nota_id);
        this.obs.listChaveEventos.push(imp.chave);
      }

    }

  };

  toggleItem = (list: any[], value: any) => {

    const index = list.indexOf(value);

    if (index === -1) {
      list.push(value);
    } else {
      list.splice(index, 1);
    }

  };

  handleDownload = async () => {

    var documento = {
      ids: this.obs.list,
      filtro: "Entrada",
      tipo: "NF-E",
      empresa: ClassificacaoStore.obs.selectedEmpresa.cnpj,
      data1: ClassificacaoStore.obs.date_start,
      data2: ClassificacaoStore.obs.date_end,
    };

    if (documento.ids.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    this.obs.loading_xmls = true;

    await NFesStore.download_xml(documento, ClassificacaoStore.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  handleEventos = async () => {

    var documento = {
      chaves: this.obs.listChaveEventos,
      empresa: ClassificacaoStore.obs.selectedEmpresa.cnpj,
      data1: ClassificacaoStore.obs.date_start,
      data2: ClassificacaoStore.obs.date_end,
      filtro: "Entrada",
      tipo: "NF-E",
    };

    if (documento.chaves.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para realizar o download.', {});
      return
    }

    this.obs.loading_xmls = true;

    await NFesStore.download_eventos(documento, ClassificacaoStore.obs.selectedEmpresa.razao_social);

    this.obs.loading_xmls = false;

  };

  handleDanfe = async () => {

    var ids = {
      ids: this.obs.list,
      filtro: "Entrada",
      tipo: "NF-E",
      empresa: ClassificacaoStore.obs.selectedEmpresa.cnpj,
      data1: ClassificacaoStore.obs.date_start,
      data2: ClassificacaoStore.obs.date_end,
    };

    if (this.obs.list.length < 1) {
      toast.warning('Você precisa selecionar os XMLs desejados para gerar.', {});
      return
    }

    this.obs.loading_danfes = true;

    if (this.obs.list.length == 1) {

      await NFesStore.view_danfe(ClassificacaoStore.obs.selectedEmpresa, ids);

    }

    if (this.obs.list.length > 1) {

      await NFesStore.download_danfe(ids, ClassificacaoStore.obs.selectedEmpresa.razao_social);

    }

    this.obs.loading_danfes = false;

  };

  render() {

    let items = ClassificacaoStore.obs.summary?.map(value => {
      return ({
        id: (value.id || value._id),
        chave: value.chave,
        numero_nota: value.numero,
        valor_total: parseFloat(value.valor),
        dest: formatCpfOrCnpj(value.cnpj_destino),
        emit: formatCpfOrCnpj(value.cnpj_origem),
        data: value.data,
        nota_id: value.nota_id,
        total_itens: value.total_itens,
        total_classificados: value.total_classificados,
      })
    })

    const formaterViewNota = (cell, row) => {
      return (
        <IconButton onClick={() => this.props.onView(row.chave)}>
          <img src="/images/view.svg" width={20} />
        </IconButton>
      )
    }

    function buttonFormatterData(cell, row) {
      return (
        <>
          {moment(cell).format("DD/MM/YYYY")} - {moment(row.data_calculo).add(3, "hours").format("HH:mm")}
        </>
      );
    };

    function formaterValue(cell, row) {
      return (
        <>
          {numeral(row.valor_total).format("$ 0,0.00")}
        </>
      );
    };

    const footerData = [
      [
        {
          label: 'Total:',
          columnIndex: 7,
          formatter: columnData => {
            let ref = 0
            for (let i = 0; i < columnData.length; i++) {
              ref += parseFloat(columnData[i].valor_total)
            }
            return `R$ ${numeral(ref).format('0,0.00')}`
          },
        },
      ]
    ]

    const options = {
      page: 1,
      sizePerPageList: [{
        text: "5",
        value: 5,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }],
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 4,
      prePage: "Ante",
      nextPage: "Próxima",
      firstPage: "Início",
      lastPage: "Última",
      paginationShowsTotal: this.renderShowsTotal,
      paginationPosition: "bottom",
      searchField: this.createCustomSearchField,
      // hideSizePerPage: true,
      // alwaysShowAllBtns: true,
      // withFirstAndLast: false,
    };

    const formaterPdf = (cell, row) => {
      return (
        <IconButton onClick={() => this.handleViewPDF(row)}>
          <img src="images/danfe_icon.svg" width={25}/>
        </IconButton>
      )
    }

    const formaterXml = (cell, row) => {
      return (
        <IconButton onClick={() => this.handleViewXML(row)}>
          <img src="images/xml-extension.png" width={25}/>
        </IconButton>
      )
    }

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      onSelectAll: this.onSelectAll,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      bgColor: "rgba(27, 98, 111, 0.1)",
      selected: this.obs.list
    };

    const formaterNotaClass = (cell, row) => {
      return (
        <Tooltip content={<span style={{ letterSpacing: 0.5 }}>
          Total de itens: {row.total_itens}<br/>
          Classificados: {row.total_classificados}
        </span>}>
          {row.total_itens === row.total_classificados
            ? (<img src="/images/checked.png" width="20px" />)
            : (<img src="/images/cancel.svg" width="20px" />)
          }
        </Tooltip>
      )
    }

    return (
      <>

        <MDBRow>
          <MDBCol md="12" className="btns-Drop">
            <MDBDropdown>
              <MDBDropdownToggle caret className="btnDefault">
                Com os Selecionados
              </MDBDropdownToggle>
              <MDBDropdownMenu basic>
                <MDBDropdownItem onClick={this.handleDownload} className="actionMani">
                  <img src="images/xml.svg" width={25} className="iconsActionMani" />{" "}
                  Download XML
                </MDBDropdownItem>
                <MDBDropdownItem onClick={this.handleDanfe} className="actionMani">
                  <img src="images/danfe.svg" width={25} className="iconsActionMani" />{" "}
                  DANFE em PDF
                </MDBDropdownItem>
                <MDBDropdownItem onClick={this.handleEventos} className="actionMani">
                  <img src="images/xml.svg" width={25} className="iconsActionMani" />{" "}
                  Download Eventos
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </MDBCol>
        </MDBRow>

        <br />

        <div style={{ marginBottom: "120px" }}>
          <BootstrapTable
            data={items}
            className="table table-hover dataTable tableFooter"
            footerData={footerData} footer search pagination
            options={options}
            selectRow={selectRowProp}
          >
            <TableHeaderColumn dataField="nota_id" width="1%" isKey={true} hidden >#</TableHeaderColumn>
            <TableHeaderColumn dataFormat={formaterViewNota} width="5%"></TableHeaderColumn>
            <TableHeaderColumn dataField="chave" width="20%">Chave</TableHeaderColumn>
            <TableHeaderColumn dataField="numero_nota" headerAlign='center' dataAlign='center' width="15%">Número da Nota</TableHeaderColumn>
            <TableHeaderColumn dataField="emit" width="15%">Emitente</TableHeaderColumn>
            <TableHeaderColumn dataField="dest" width="15%">Destinatário</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterData} dataField="data" width="15%">Data da Nota</TableHeaderColumn>
            <TableHeaderColumn dataFormat={formaterValue} dataField="valor_total" width="15%">Valor Total</TableHeaderColumn>
            <TableHeaderColumn dataFormat={formaterNotaClass} headerAlign='center' dataAlign='center' width="10%">Classificada</TableHeaderColumn>
            <TableHeaderColumn dataFormat={formaterPdf} headerAlign='center' dataAlign='center' width="5%"></TableHeaderColumn>
            <TableHeaderColumn dataFormat={formaterXml} headerAlign='center' dataAlign='center' width="5%"></TableHeaderColumn>
          </BootstrapTable>
        </div>

        <LoadingModal open={this.obs.loading_danfes} onClose={() => this.obs.loading_danfes = false} title={"Gerando DANFES"} />
        <LoadingModal open={this.obs.loading_xmls} onClose={() => this.obs.loading_xmls = false} title={"Gerando XMLs"} />

      </>
    );
  }
}
